import { Pipe, PipeTransform, inject } from '@angular/core';
import {TranslateService} from '../_services/translate.service';

@Pipe({
    name: 'i18n'
})
export class TranslatePipe implements PipeTransform {
  private trans = inject(TranslateService);


  transform(key: string, mapKeys?: object): any {
    return this.trans.translate(key, mapKeys);
  }

}
